    import axios from 'axios'

    export default {

      data() {
        return {
          serverErrors: '',
          filesOrder: [],
          filesFinish: [],
          fileProgress: 0,
          fileCurrent: '',
          domain: '',
          activeOptions: false,
          newPath: '',
          countFiles: 0,
          lengthSession: 0,
          items: [],
          typeFiles: 'all',
          checkBoxValue:[],
          activePath: '/',
          loading: true,
          dataBase: {
            find: 'files',
          },

          isOpen: false,
          historyFolder: '/files',
          activeId: null,

        }
      },
      created() {
        this.domain =  this.$store.getters.getCloudDomain

        this.getItems()

        let folder = '/files'


        document.addEventListener('click', () => this.activeId = null);
      },

 
      methods: {
        finishedEditFile(data) {
            if(data == 'false') {
            this.showAlertSuccess('System','Файл вече съществува')
          } else {
            console.log(this.items)
            const index = this.items.findIndex((item) => item.id == data.id)
            this.items.splice(index, 1, data)
            this.activeOptions = false
          }

        },

        addItemBottomFile(data) {
 
          if(data == 'false') {
            this.showAlertSuccess('System','Файл вече съществува')
          } else {
           this.items.push({
             id: data.id,
             title: data.title,
             type: data.type,
             icon: data.icon,
             path: data.path,
             checked: false,
           })
         }
         
         this.activeOptions = false
       },
       finishedMoveFile(data) {
         const index = this.items.findIndex((item) => item.id == data.id)
         this.items.splice(index, 1)

         this.activeOptions = false
       },
       getItems() {
        
          var url = this.domain+'system/files/'+this.typeFiles


        axios.get(url)
        .then(response => {
          this.items = response.data
          this.loading = false
    

        })
        .catch(error => {})

      },
      removeFile(item, index) {
       axios.post(this.domain+'system/files/destroy', {
        path: item.path,
        title: item.title,
        type: item.type,

      })
       .then(response => {

        this.activeId = 0

        this.items.splice(index, 1)

      })
       .catch(error => {})
     },

     openModalCreateFolder(item, type) {
       var d = { openModal:true , path: this.activePath, item: item };

       eventBus.$emit('openModalCreateFolder', d)
     },
     openModalMoveFolder(item, act) {


       var d = { openModal:true , path: this.activePath, item: item, act:act,mass: false };


       eventBus.$emit('openModalMoveFolder', d)
     },
     changeActiveOptions(id) {
       this.activeId = id               
       this.activeOptions ? this.activeOptions = false : this.activeOptions =true

     },

     backFolder() {

      this.newPath = this.historyFolder
      this.activePath = this.historyFolder

      this.openFolder(this.historyFolder)
      if(this.historyFolder == '/files' || this.historyFolder == '' ) {
        this.historyFolder = ''
      } else {
        var lastIndex =  this.historyFolder.lastIndexOf("/");

        this.historyFolder =  this.historyFolder.substring(0, lastIndex);


      }


    },
    clickInputMask() {
      this.fileInputChange()
    },

    fileInputChange() {
      let files = Array.from(event.target.files)


      for (var i = files.length - 1; i >= 0; i--) {
        this.uploadFile(files[i])
      }

    },

    uploadFile(item) {
     let form = new FormData()
     form.append('image', item)
     form.append('path', this.activePath)


     axios.post(this.cloudDomain+'uploads', form, {
      onUploadProgress: (itemUpload) => {

       this.fileProgress = Math.round( (itemUpload.loaded / itemUpload.total) * 100 )
       this.fileCurrent = item.name + ' ' + this.fileProgress;
     }
   })
     .then(response => {
      
      this.items.push({
       id: response.data.id,
       title: response.data.title,
       type: response.data.type,
       icon: response.data.icon,
       path: response.data.path,
       checked: false,
     })
      console.log(this.items)

      this.fileProgress = 0
      this.fileCurrent = ''
      this.filesFinish.push(item)
      this.filesOrder.splice(item, 1)
    })
     .catch(error => {
      console.log(error)
      this.fileProgress = 0
      this.fileCurrent = ''
      this.filesFinish.push(item)
      this.filesOrder.splice(item, 1)

      this.serverErrors = Object.values(error.response.data)
      

    })

   },

   clickImage(item) {

     if(item.type == 'folder') {

      var folder = item.path + '/' + item.title

      this.newPath = item.path + '/' + item.title 

      this.historyFolder = item.path
      this.activePath = folder



      this.openFolder(folder)

      this.clearChecked()




    } else if(item.type == 'pdf') {

      eventBus.$emit('exportLinkFile', item.path + '/' +item.title)

    }


  },

  openFolder(folder) {

    axios.post(this.domain+'open-folder/'+this.typeFiles, {
      folder: folder,
    })
    .then(response => {
      this.items = response.data
      console.log(this.items)

    })
  },
  searchItems() {

    axios.post(this.domain+'core/search/'+this.dataBase.find, {
      value: this.search
    })

    .then(response => {

      this.items = response.data

      console.log(this.items)

      for (var i = 0; i < this.items.length; i++) {
        var mainImage = response.data[i]['images'].split(';')
        this.items[i]['images'] = mainImage[0]

      }
    })
    .catch(error => { })

  },
  changeFilter(data) {
    this.dataBase.find = data
    this.getItems()
  },
  changeStateCheckbox(item) {

            // var el = this.checkBoxValue.filter(it => it.id == item.id)

            var check = true;
            for(var i = 0;i < this.checkBoxValue.length;i++) {

              if(this.checkBoxValue[i].id == item.id) {

                this.checkBoxValue.splice(i, 1)
                var check = false;
              }
            }

            if(check) {
              this.checkBoxValue.push({
                id: item.id,
                path: item.path,
                title: item.title,
                type: item.type,
              })
            }

            this.checkBoxValue

            console.log(this.checkBoxValue)

          },
          massActItem(item, act) {

            if(act != 'remove') {
             var d = { openModal:true , path: this.activePath, item: item, act:act, mass: true };

             eventBus.$emit('openModalMoveFolder', d)



           } else {

            axios.post(this.domain+'system/files/mass/remove', {
              checked: this.checkBoxValue,

            })
            .then(response => {
              this.finishedMoveFileMass('removed')


            })
            .catch(error => {})

          }



          return 


        },

        finishedMoveFileMass(data) {

          console.log(this.checkBoxValue)


          for(var i = 0; i < this.checkBoxValue.length;i++) {

            if(data == 'moved' || data == 'removed' ) {
              const index = this.items.findIndex((item) => item.id == this.checkBoxValue[i].id)
              this.items.splice(index, 1)

        // this.items.splice(j, 1)


      } else if(data == 'exists') {

      } else {

        for(var i = 0;i <  this.items.length;i++) {

          this.items[i].check = false

        }

      }
    // const index = this.items.findIndex((item) => item.id == this.checkBoxValue[i].id)
    // this.items.splice(index, 1)

  }
// this.activeOptions = false
this.checkBoxValue = []


return 
for(var i = 0; i < this.checkBoxValue.length;i++) {
  for (var j = this.items.length - 1; j >= 0; j--) {
    if(this.items[j].id == this.checkBoxValue[i].id) {
     console.log('this.items[j].path = ' + this.items[j].id)
     console.log('this.checkBoxValue[i].path = ' + this.checkBoxValue[i].id)
     if(data == 'removed') {
      this.items.splice(j, 1)


    } else if(data == 'moved') {
      this.items.splice(j, 1)


    } else if(data == 'removed') {
      this.items.splice(j, 1)


    } else if(data == 'exists') {

    }  else if(data == 'copied') {

    } else {
      this.items[j]['check'] = false

      this.items.unshift(data) 
    }


  }

}
}
},

checkAll() {

  if(this.checkBoxValue.length == 0) {
    this.checkBoxValue = []

    for (var j = this.items.length - 1; j >= 0; j--) {
      this.checkBoxValue.push({
        id: this.items[j].id
      })
      this.items[j]['check'] = true
    }
  } else {
    this.clearChecked()

  }



}, 
clearChecked() {
 for(var i = 0;i <  this.items.length;i++) {

  this.items[i].check = false

}
this.checkBoxValue = []
}


},

computed: {
      
        checkBoxesState() {
          return this.checkBoxValue.length
        },
        cloudDomain() {
          return this.$store.getters.getMainDomainName

        },
        totalCountImages() {
          return this.items.filter(item => item.type == 'png' || item.type == 'jpg').length
        }

      },

      watch: {
         '$route.params.type': function (id) {
            this.$route.params.type ? this.dataBase.find =  'files/'+this.$route.params.type : this.dataBase.find = 'files'
      this.getItems()
    }
      }
    }


// WEBPACK FOOTER //
// ./src/mixins/filemanager.js